import React, { useEffect, useRef } from 'react';
import { useThreeScene } from '../hooks/useThreeScene';
import { useMobileControls } from '../hooks/useMobileControls';

const ThreeScene = ({ 
  currentSection, 
  onServiceClick, 
  onButtonClick,
  onShowreelClick, 
  onHelpClick,
  isMobile, 
  isModalOpen,
  cinematicMode 
}) => {
  const canvasRef = useRef();
  const mobileControlsRef = useRef();

  const { 
    scene, 
    camera, 
    renderer, 
    controls,
    serviceNodes,
    navigateToSection 
  } = useThreeScene({
    canvas: canvasRef.current,
    onServiceClick,
    onButtonClick,
    onHelpClick,
    isModalOpen,
    cinematicMode
  });

  const { setupMobileControls } = useMobileControls({
    container: mobileControlsRef.current,
    camera,
    controls,
    isMobile
  });

  useEffect(() => {
    if (currentSection && navigateToSection) {
      navigateToSection(currentSection);
    }
  }, [currentSection, navigateToSection]);

  useEffect(() => {
    if (isMobile && mobileControlsRef.current) {
      setupMobileControls();
    }
  }, [isMobile, setupMobileControls]);

  return (
    <>
      <canvas ref={canvasRef} id="bg" />
      {isMobile && <div ref={mobileControlsRef} id="mobile-controls" />}
    </>
  );
};

export default ThreeScene;